'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ScreenReaderMessage = require('./components/ScreenReaderMessage.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ScreenReaderMessage).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-screen-reader-message/lib/index.js
// module id = 45
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12